import { render } from "./AppIntegrationRequest.vue?vue&type=template&id=70469073&scoped=true"
import script from "./AppIntegrationRequest.vue?vue&type=script&lang=js"
export * from "./AppIntegrationRequest.vue?vue&type=script&lang=js"

import "./AppIntegrationRequest.vue?vue&type=style&index=0&id=70469073&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70469073"]])

export default __exports__